import Header from "../components/layout/Header"; 
import HeroSection from "../components/sections/HeroSection"; 
import MissionSection from "../components/sections/MissionSection"; 
import Footer from "../components/layout/Footer"; 
import MadeToMeasureIntro from "../components/sections/MadeToMeasureIntro";
import madeToMeasureContent from "../content/madetomeasure/intro.json";
import homeContent from "../content/home/home.json"; 
import VideoPreviewShowcase from "../components/sections/VideoPreviewShowcase";
import Testimonials from "../components/sections/Testimonials";
import quickLinksContent from "../content/home/quicklinks.json";
import QuickLinksSection from "../components/sections/QuickLinksSection";

export default function HomePage() {
  return (
    <div className="bg-gray-100 min-h-screen">
      <Header />
      <HeroSection content={homeContent.hero} />    
      <MissionSection />
      <MadeToMeasureIntro content={madeToMeasureContent} />     
      <QuickLinksSection content={quickLinksContent} />
      <Testimonials />
      <VideoPreviewShowcase />
      <Footer />
    </div>
  );
} 